import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  EVENT_CREATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CITY_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import defaultIcon from "../../assets/images/defaultimage.png";
import { EVENT_CREATED } from "../../constant/constant";
import { ValidationMessage, hasRole } from "../../components/Utils";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import moment from "moment";
import "flatpickr/dist/themes/material_red.css";
import { Image } from "react-bootstrap";
import { Timepicker } from "timepicker-ui-react";
import "timepicker-ui/main.css";

const ChapterCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [cityOptions, setCityOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filter, setFilter] = useState([]);

  const selectStateRef = useRef(null);
  const selectCityRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleCityClear = () => {
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(EVENT_CREATE, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(EVENT_CREATED);
          navigate("/events");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    let initialForm = {};
    let initialFilter = {};

    if (hasRole([6])) {
      initialForm.country_id = auth_user?.country_id;
    }

    if (hasRole([7])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
    }

    if (hasRole([8])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
      initialForm.city_id = auth_user?.city_id;
      initialFilter = {
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        city_id: auth_user?.city_id,
      };
    }

    if (hasRole([2])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
      initialForm.city_id = auth_user?.city_id;
      initialForm.region_id = auth_user?.region_id;
      initialFilter = {
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        city_id: auth_user?.city_id,
        region_id: auth_user?.region_id,
      };
    }

    if (hasRole([3])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
      initialForm.city_id = auth_user?.city_id;
      initialForm.region_id = auth_user?.region_id;
      initialForm.chapter_id = auth_user?.chapter_id;
      initialFilter = {
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        city_id: auth_user?.city_id,
        region_id: auth_user?.region_id,
        chapter_id: auth_user?.chapter_id,
      };
    }

    setForm((prev) => ({ ...prev, ...initialForm }));
    setFilter(initialFilter);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        const cityResponse = await axios.get(CITY_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        setCityOptions(cityResponse.data.data);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [JSON.stringify(filter)]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Events</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/events"}>
                    <span>Events List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Create Event</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/events"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    {hasRole([1]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country<span className="text-danger">*</span>
                          </label>
                          <Select
                            name="country_id"
                            isClearable
                            options={countryOptions}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({
                                ...form,
                                country_id: Number(selected?.value),
                                state_id: null,
                                city_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                country_id: selected?.value,
                                state_id: null,
                                city_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state_id" className="form-label">
                            State<span className="text-danger">*</span>
                          </label>
                          <Select
                            ref={selectStateRef}
                            name="state_id"
                            isClearable
                            options={stateOptions}
                            onChange={(selected) => {
                            handleCityClear();
                            setForm({
                                ...form,
                                state_id: Number(selected?.value),
                                city_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                state_id: selected?.value,
                                city_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="city_id" className="form-label">
                          City<span className="text-danger">*</span>
                        </label>
                        <Select
                          ref={selectCityRef}
                          isClearable
                          name="city_id"
                          options={cityOptions}
                          onChange={(selected) => {
                            handleRegionClear();
                            setForm({
                              ...form,
                              city_id: Number(selected?.value),
                              region_id: null,
                              chapter_id: null,
                            });
                            setFilter({
                              ...filter,
                              city_id: selected?.value,
                              region_id: null,
                              chapter_id: null,
                            });
                          }}
                        />
                        <ValidationMessage error={errors} name="city_id" />
                      </div>
                    )}

                    {hasRole([1, 6, 7, 8]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="region_id" className="form-label">
                            Region<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            ref={selectRegionRef}
                            options={regionOptions}
                            onChange={(selected) => {
                              handleChapterClear();
                              setForm({
                                ...form,
                                region_id: Number(selected?.value),
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                region_id: selected?.value,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="region_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7, 8, 2]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="chapter_id">
                            Circle
                          </label>
                          <Select
                            isClearable
                            ref={selectChapterRef}
                            options={chapterOptions}
                            onChange={(selected) => {
                              setForm({ ...form, chapter_id: selected?.value });
                            }}
                          />
                          <ValidationMessage error={errors} name="chapter_id" />
                        </div>
                      </div>
                    )}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="event_date">
                          Event Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                             dateFormat: "d/m/Y",
                             enableTime: false,
                          }}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              event_date: moment(selected[0]).format(
                                "DD/MM/YYYY",
                              ),
                            })
                          }
                          value={form?.event_date || ""}
                          placeholder="Select Event Date"
                        />
                        <ValidationMessage error={errors} name="event_date" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="from_time">
                          From Time<span className="text-danger">*</span>
                        </label>
                        <Timepicker
                          id="from_time"
                          className="form-control"
                          placeholder="Select From Time"
                          options={{
                            clock: { type: "12h" },
                            ui: { clearButton: true },
                          }}
                          onConfirm={(data) => {
                            const hour = data?.hour;
                            const minutes = data?.minutes;
                            const type = data?.type; // "AM" or "PM" for 12h
                            let timeStr = `${hour}:${minutes} ${type}`;
                            const formatted = moment(timeStr, [
                              "h:mm A",
                              "HH:mm",
                            ]).format("HH:mm:ss");
                            setForm({ ...form, from_time: formatted });
                          }}
                          onClear={() => {
                            setForm({ ...form, from_time: "" });
                          }}
                        />
                        <ValidationMessage error={errors} name="from_time" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="to_time">
                          To Time<span className="text-danger">*</span>
                        </label>
                        <Timepicker
                          id="to_time"
                          className="form-control"
                          placeholder="Select To Time"
                          options={{
                            clock: { type: "12h" },
                            ui: { clearButton: true },
                          }}
                          onConfirm={(data) => {
                            const hour = data?.hour;
                            const minutes = data?.minutes;
                            const type = data?.type; // "AM" or "PM" for 12h
                            let timeStr = `${hour}:${minutes} ${type}`;
                            const formatted = moment(timeStr, [
                              "h:mm A",
                              "HH:mm",
                            ]).format("HH:mm:ss");
                            setForm({ ...form, to_time: formatted });
                          }}
                          onClear={() => {
                            setForm({ ...form, to_time: "" });
                          }}
                        />
                        <ValidationMessage error={errors} name="to_time" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="event_title">
                          Event Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="event_title"
                          placeholder="Event Title"
                          onChange={(e) =>
                            setForm({ ...form, event_title: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="event_title" />
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="image_path" className="form-label">
                          Event Image(16:9)
                          <span className="text-danger">*</span> (ex.
                          1920wx1080h)
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>2MB</span>
                          </div>
                          {/* <div>
                            <label htmlFor="pixel">Min height*width: </label>
                            <span>430px * 600px</span>
                          </div> */}
                        </div>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={(e) =>
                          e.target.files.length > 0
                            ? setForm({
                                ...form,
                                image_path: e.target.files[0],
                                cardImage: URL.createObjectURL(
                                  e.target.files[0],
                                ),
                              })
                            : ""
                        }
                      />
                      <div className="m-3">
                        <Image
                          width={120}
                          height={80}
                          src={form?.cardImage ? form?.cardImage : defaultIcon}
                        />
                      </div>
                      <ValidationMessage error={errors} name="image_path" />
                    </div>

                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="qrcode_path" className="form-label">
                          QR Code Image(1:1)
                          <span className="text-danger">*</span> (ex. 200wx200h)
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>2MB</span>
                          </div>
                          {/* <div>
                            <label htmlFor="pixel">Min height*width: </label>
                            <span>430px * 600px</span>
                          </div> */}
                        </div>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={(e) =>
                          e.target.files.length > 0
                            ? setForm({
                                ...form,
                                qrcode_path: e.target.files[0],
                                qrImage: URL.createObjectURL(e.target.files[0]),
                              })
                            : ""
                        }
                      />
                      <div className="m-3">
                        <Image
                          width={100}
                          height={100}
                          src={form?.qrImage ? form?.qrImage : defaultIcon}
                        />
                      </div>
                      <ValidationMessage error={errors} name="qrcode_path" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="event_description"
                        >
                          Event Description
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="event_description"
                          rows="6"
                          placeholder="Event description"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              event_description: e.target.value,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="event_description"
                        />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/events"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterCreate;
